import DoctorOwnProfileComponent from '../components/DoctorOwnProfile';

function DoctorOwnProfile() {
  return <DoctorOwnProfileComponent></DoctorOwnProfileComponent>;
}

export default DoctorOwnProfile;
